import { getFlattenColumns } from "./utils"

export default {
  props: {
    columns: Array,
    store: Object,
    rowSelection: Object,
    fixed: String,
    scrollHandler: Function,
  },
  computed: {
    showSelectCol() {
      return Boolean(this.rowSelection && this.rowSelection.onChange) && this.fixed !== "right"
    },
    tableStyle() {
      const selectColWidth = this.showSelectCol ? this.store.layout.selectColWidth : 0
      const width = this.columns.reduce((prev, next) => prev + next.width, selectColWidth)
      return width ? { width: `${width}px` } : {}
    },
    flattenColumns() {
      return getFlattenColumns(this.columns)
    },
  },
}
